<template>
  <div :class="eventClass" :style="eventBg">
    <div class="inner-content pb-5">
      <Alert></Alert>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/helpers'
import Alert from '@/components/Utils/Alert.vue'

export default {
  name: 'EventDetail',
  components: { Alert },

  mounted () {
    this.fetchEvent()
  },

  methods: {
    formatDate,

    fetchEvent () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getEvent', this.$route.params.slug).then(() => {
        this.$store.commit('setLoading', false)
        this.chooseTab()
      }).catch((err) => {
        console.error(err)
        this.$store.commit('setLoading', false)
        this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на заседанието.' })
      })
    },

    // Choose a tab (sub-view) to display based on what sections the event has
    chooseTab () {
      const tabs = {
        'event-invite': this.event.invite.length > 0,
        'event-agenda': this.event.content.rendered.length > 0,
        'event-proposals': this.event.proposals.length > 0,
        'event-voting': this.event.questionnaire.length > 0,
        'event-news': this.event.news.length > 0
      }

      for (let [name, exists] of Object.entries(tabs)) {
        if (exists) {
          this.$router.replace({ name, params: { slug: this.$route.params.slug } })
          break;
        }
      }
    }
  },

  computed: {
    ...mapGetters(['isCordova', 'event']),

    eventClass () {
      return this.$route.name === 'event' ? 'event' : 'event ' + this.$route.name
    },

    eventBg () {
      if (this.$route.name === 'event') {
        let bg = this.$store.getters.eventBg
        return bg !== false ? { 'background-image': 'url(' + bg + ')' } : false
      } else {
        return {}
      }
    },

    headerClass () {
      return this.$route.name === 'event' ? 'header-full' : 'header-collapsed'
    },

    userIsEditor () {
      return this.$store.getters.loggedIn &&
        (this.$store.getters.user.roles.indexOf('editor') > -1 ||
          this.$store.getters.user.roles.indexOf('administrator') > -1)
    },
  }
}
</script>
